import { Image } from "@chakra-ui/react";
import React, { memo } from "react";
import InsightBowlImage from "../../assets/images/it_bowl.png";

const InsightTimerLogo = () => {
  return <Image src={InsightBowlImage} width="104px" height="104px" />;
};

export default memo(InsightTimerLogo);
